
// import React, { useEffect, useState, useMemo } from "react";
// import { useApp } from "../../../context/AppContext";
// import DataTable from "../../../components/DataTable/DataTable";
// import StatusBadge from "../../../components/StatusBadge/StatusBadge";
// import PageHeader from "../../../components/PageHeader/PageHeader";
// import Modal from "../../../components/Modal/Modal";
// import Button from "../../../components/Form/Button";
// import Input from "../../../components/Form/Input";
// import { useToast } from "../../../context/ToastContext";
// import "./Orders.css";

// /**
//  * ManagerOrders
//  * - fetches manager orders (provider reads manager id from token)
//  * - normalizes the backend shape to the table shape
//  * - includes a debounced client-side search box
//  */

// const useDebounced = (value, delay = 300) => {
//   const [debounced, setDebounced] = useState(value);
//   useEffect(() => {
//     const t = setTimeout(() => setDebounced(value), delay);
//     return () => clearTimeout(t);
//   }, [value, delay]);
//   return debounced;
// };

// const ManagerOrders = () => {
//   const {
//     managerOrders,
//     fetchManagerOrdersWithAbort,
//     currentUser,
//     pumps,
//     updateOrder,
//   } = useApp();

//   const { showToast } = useToast();
//   const [selectedOrder, setSelectedOrder] = useState(null);
//   const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(false);
//   const [completeForm, setCompleteForm] = useState({ otp: "", billImage: null });

//   // simple search state
//   const [searchTerm, setSearchTerm] = useState("");
//   const debouncedSearch = useDebounced(searchTerm, 250);

//   // Find current manager's pump (if any)
//   const currentPump = useMemo(() => {
//     return pumps.find((p) => p.managerPhone === currentUser?.phone);
//   }, [pumps, currentUser]);

//   // Fetch manager orders on mount / when currentUser changes
//   useEffect(() => {
//     if (!currentUser) return;

//     console.info("[ManagerOrders] fetching manager orders for user:", {
//       id: currentUser._id ?? currentUser.id ?? currentUser.phone,
//       phone: currentUser.phone,
//       name: currentUser.name,
//     });

//     const { promise, controller } = fetchManagerOrdersWithAbort({ page: 1, limit: 200 });
//     promise
//       .then(() => {
//         console.info("[ManagerOrders] fetchManagerOrders resolved");
//       })
//       .catch((err) => {
//         console.error("[ManagerOrders] Error fetching manager orders in component:", err);
//       });

//     return () => {
//       controller.abort();
//       console.debug("[ManagerOrders] aborted fetch (cleanup)");
//     };
//   }, [currentUser, fetchManagerOrdersWithAbort]);

//   // Map/normalize raw managerOrders into the shape the DataTable expects
//   const mappedOrders = useMemo(() => {
//     if (!Array.isArray(managerOrders)) return [];

//     return managerOrders
//       .filter(Boolean)
//       .map((o) => {
//         const id = o._id ?? o.id ?? o.order_id ?? String(Math.random());
//         const orderNumber = o.order_id ?? o.orderNumber ?? o.order_number ?? id;
//         const customerName = o.user?.name ?? o.user?.fullName ?? o.customerName ?? o.customer ?? "—";
//         const vehicleNumber = o.vehicle?.reg_no ?? o.vehicle?.regNo ?? o.vehicleNumber ?? "—";
//         const quantityLiters = Number(o.fuel_quantity ?? o.quantityLiters ?? o.quantity ?? 0);
//         const amount = Number(o.order_total ?? o.amount ?? o.total ?? 0);
//         const createdAt = o.createdAt ?? o.created_at ?? o.updatedAt ?? o.updated_at ?? null;

//         let orderStatus = "pending";
//         if (o.is_deleted || o.is_refunded) orderStatus = "cancelled";
//         else if (o.is_completed === true || o.is_completed === "true") orderStatus = "completed";
//         else if (o.is_accepted === true || o.is_accepted === "true") orderStatus = "accepted";

//         return {
//           __raw: o, // original object for modal/details if needed
//           id,
//           orderNumber,
//           customerName,
//           vehicleNumber,
//           quantityLiters,
//           amount,
//           orderStatus,
//           createdAt,
//           pumpName: o.pump?.brand ?? o.pumpName ?? o.pump?.name ?? "—",
//         };
//       });
//   }, [managerOrders]);

//   // Filter mappedOrders by current pump (if present) and search term
//   const pumpAndSearchFiltered = useMemo(() => {
//     const pumpFiltered = currentPump
//       ? mappedOrders.filter((o) => {
//           // match by pump id or pump name if available in raw
//           const rawPumpId = o.__raw?.pump_id ?? o.__raw?.pump?._id ?? o.__raw?.pumpId;
//           const matchesPumpId = rawPumpId ? String(rawPumpId) === String(currentPump?._id ?? currentPump?.pump_id) : true;
//           const matchesPumpName =
//             (currentPump?.pumpName && o.pumpName && o.pumpName === currentPump.pumpName) || true;
//           // allow either id match or fallback to brand comparison
//           return matchesPumpId || (o.pumpName && currentPump && String(o.pumpName) === String(currentPump.brand));
//         })
//       : mappedOrders.slice();

//     // if no search, return pumpFiltered
//     if (!debouncedSearch || debouncedSearch.trim() === "") return pumpFiltered;

//     const q = debouncedSearch.trim().toLowerCase();
//     return pumpFiltered.filter((row) => {
//       return (
//         String(row.orderNumber).toLowerCase().includes(q) ||
//         String(row.customerName ?? "").toLowerCase().includes(q) ||
//         String(row.vehicleNumber ?? "").toLowerCase().includes(q) ||
//         String(row.pumpName ?? "").toLowerCase().includes(q) ||
//         String(row.amount ?? "").toLowerCase().includes(q)
//       );
//     });
//   }, [mappedOrders, currentPump, debouncedSearch]);

//   // debug table: show a concise snapshot
//   useEffect(() => {
//     console.debug("[ManagerOrders] mappedOrders length:", mappedOrders.length);
//     console.debug("[ManagerOrders] filtered (pump+search) length:", pumpAndSearchFiltered.length);
//     if (pumpAndSearchFiltered.length > 0) {
//       try {
//         console.table(
//           pumpAndSearchFiltered.slice(0, 5).map((r) => ({
//             id: r.id,
//             orderNumber: r.orderNumber,
//             customer: r.customerName,
//             vehicle: r.vehicleNumber,
//             qty: r.quantityLiters,
//             amount: r.amount,
//             status: r.orderStatus,
//             pump: r.pumpName,
//           }))
//         );
//       } catch (e) {
//         console.debug("[ManagerOrders] console.table error", e);
//       }
//     }
//   }, [mappedOrders, pumpAndSearchFiltered]);

//   const columns = [
//     { key: "orderNumber", label: "Order #", width: "150px" },
//     { key: "customerName", label: "Customer" },
//     { key: "vehicleNumber", label: "Vehicle" },
//     {
//       key: "quantityLiters",
//       label: "Quantity (L)",
//       render: (value) => `${value} L`,
//     },
//     {
//       key: "amount",
//       label: "Amount",
//       render: (value) => `₹${Number(value).toLocaleString("en-IN")}`,
//     },
//     {
//       key: "orderStatus",
//       label: "Status",
//       render: (value) => <StatusBadge status={value} type="order" />,
//     },
//     {
//       key: "createdAt",
//       label: "Created",
//       render: (value) => (value ? new Date(value).toLocaleDateString("en-IN") : "-"),
//     },
//     {
//       key: "actions",
//       label: "Actions",
//       sortable: false,
//       render: (value, row) => {
//         if (row.orderStatus === "pending") {
//           return (
//             <div className="order-actions">
//               <Button
//                 size="small"
//                 variant="primary"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleAcceptOrder(row.id ?? row._id);
//                 }}
//               >
//                 Accept
//               </Button>
//               <Button
//                 size="small"
//                 variant="outline"
//                 onClick={(e) => {
//                   e.stopPropagation();
//                   handleDeclineOrder(row.id ?? row._id);
//                 }}
//               >
//                 Decline
//               </Button>
//             </div>
//           );
//         } else if (row.orderStatus === "accepted") {
//           return (
//             <Button
//               size="small"
//               variant="primary"
//               onClick={(e) => {
//                 e.stopPropagation();
//                 handleOpenCompleteModal(row);
//               }}
//             >
//               Mark Complete
//             </Button>
//           );
//         }
//         return "-";
//       },
//     },
//   ];

//   const handleAcceptOrder = async (orderId) => {
//     try {
//       await updateOrder(orderId, { orderStatus: "accepted" });
//       showToast("Order accepted successfully!", "success");
//     } catch (err) {
//       console.error(err);
//       showToast("Failed to accept order", "error");
//     }
//   };

//   const handleDeclineOrder = async (orderId) => {
//     try {
//       await updateOrder(orderId, { orderStatus: "cancelled" });
//       showToast("Order declined", "info");
//     } catch (err) {
//       console.error(err);
//       showToast("Failed to decline order", "error");
//     }
//   };

//   const handleOpenCompleteModal = (order) => {
//     setSelectedOrder(order);
//     setIsCompleteModalOpen(true);
//   };

//   const handleCompleteOrder = async () => {
//     if (!completeForm.otp) {
//       showToast("Please enter OTP", "error");
//       return;
//     }

//     try {
//       await updateOrder(selectedOrder.id ?? selectedOrder._id, {
//         orderStatus: "completed",
//         completedAt: new Date().toISOString(),
//       });

//       showToast("Order marked as completed!", "success");
//       setIsCompleteModalOpen(false);
//       setCompleteForm({ otp: "", billImage: null });
//     } catch (err) {
//       console.error(err);
//       showToast("Failed to complete order", "error");
//     }
//   };

//   const handleFileChange = (e) => {
//     const file = e.target.files?.[0];
//     if (file) {
//       setCompleteForm((prev) => ({ ...prev, billImage: file }));
//       showToast("Bill image selected (demo mode)", "info");
//     }
//   };

//   return (
//     <div className="manager-orders">
//       <PageHeader title="Orders" />

//       {/* Search input (local client-side search) */}
//       <div style={{ marginBottom: 12, maxWidth: 420 }}>
//         <Input
//           placeholder="Search orders by order #, customer, vehicle, pump or amount..."
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//       </div>

//       <DataTable
//         columns={columns}
//         data={pumpAndSearchFiltered}
//         // your DataTable might already have its own search; we pass filtered data
//         searchable={false}
//         searchPlaceholder="Search orders..."
//       />

//       {/* If you want a friendly 'no orders' message */}
//       {pumpAndSearchFiltered.length === 0 && (
//         <div style={{ padding: 16, color: "#666" }}>
//           No orders found {debouncedSearch ? `for "${debouncedSearch}"` : "for this pump"}.
//         </div>
//       )}

//       <Modal
//         isOpen={isCompleteModalOpen}
//         onClose={() => {
//           setIsCompleteModalOpen(false);
//           setCompleteForm({ otp: "", billImage: null });
//         }}
//         title="Mark Order as Completed"
//         size="medium"
//       >
//         {selectedOrder && (
//           <div className="complete-order-form">
//             <div className="order-summary">
//               <p>
//                 <strong>Order:</strong> {selectedOrder.orderNumber ?? selectedOrder.order_id}
//               </p>
//               <p>
//                 <strong>Customer:</strong> {selectedOrder.customerName ?? selectedOrder.__raw?.user?.name}
//               </p>
//               <p>
//                 <strong>Quantity:</strong> {selectedOrder.quantityLiters} Liters
//               </p>
//               <p>
//                 <strong>Amount:</strong> ₹{Number(selectedOrder.amount).toLocaleString("en-IN")}
//               </p>
//             </div>

//             <div className="form-section">
//               <label className="file-upload-label">
//                 Upload Bill Image
//                 <input type="file" accept="image/*" onChange={handleFileChange} className="file-upload-input" />
//                 <span className="file-upload-button">Choose File</span>
//                 {completeForm.billImage && <span className="file-upload-name">{completeForm.billImage.name}</span>}
//               </label>
//             </div>

//             <Input
//               label="Customer OTP"
//               type="text"
//               placeholder="Enter OTP"
//               value={completeForm.otp}
//               onChange={(e) => setCompleteForm((prev) => ({ ...prev, otp: e.target.value }))}
//             />

//             <div className="modal-actions">
//               <Button
//                 variant="outline"
//                 onClick={() => {
//                   setIsCompleteModalOpen(false);
//                   setCompleteForm({ otp: "", billImage: null });
//                 }}
//               >
//                 Cancel
//               </Button>
//               <Button variant="primary" onClick={handleCompleteOrder}>
//                 Confirm Completion
//               </Button>
//             </div>
//           </div>
//         )}
//       </Modal>
//     </div>
//   );
// };

// export default ManagerOrders;



import React, { useEffect, useState, useMemo } from "react";
import { useApp } from "../../../context/AppContext";
import DataTable from "../../../components/DataTable/DataTable";
import StatusBadge from "../../../components/StatusBadge/StatusBadge";
import PageHeader from "../../../components/PageHeader/PageHeader";
import Modal from "../../../components/Modal/Modal";
import Button from "../../../components/Form/Button";
import Input from "../../../components/Form/Input";
import { useToast } from "../../../context/ToastContext";
import { apiService } from "../../../services/api";
import "./Orders.css";

/**
 * ManagerOrders - wired to accept/cancel/complete endpoints:
 *  - PUT /admin/booking/accept/:bookingId
 *  - PUT /admin/booking/cancel/:bookingId
 *  - PUT /admin/booking/complete/:bookingId
 *
 * After successful action, the list is refreshed by calling fetchManagerOrdersWithAbort().
 */

const useDebounced = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
};

const ManagerOrders = () => {
  const {
    managerOrders,
    fetchManagerOrdersWithAbort,
    currentUser,
    pumps,
    // updateOrder kept for backward compat if needed
    updateOrder,
  } = useApp();

  const { showToast } = useToast();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isCompleteModalOpen, setIsCompleteModalOpen] = useState(false);
  const [completeForm, setCompleteForm] = useState({ otp: "", billImage: null });

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearch = useDebounced(searchTerm, 250);

  const currentPump = useMemo(() => {
    return pumps.find((p) => p.managerPhone === currentUser?.phone);
  }, [pumps, currentUser]);

  // fetch manager orders on mount / when user present
  useEffect(() => {
    if (!currentUser) return;
    const { promise, controller } = fetchManagerOrdersWithAbort({ page: 1, limit: 200 });
    promise.catch((err) => {
      console.error("fetchManagerOrders error:", err);
    });
    return () => controller.abort();
  }, [currentUser, fetchManagerOrdersWithAbort]);

  // normalize backend order shape
  const mappedOrders = useMemo(() => {
    if (!Array.isArray(managerOrders)) return [];
    return managerOrders.map((o) => {
      const id = o._id ?? o.id ?? o.order_id ?? String(Math.random());
      const orderNumber = o.order_id ?? o.orderNumber ?? o.order_number ?? id;
      const customerName = o.user?.name ?? o.user?.fullName ?? o.customerName ?? "—";
      const vehicleNumber = o.vehicle?.reg_no ?? o.vehicle?.regNo ?? o.vehicleNumber ?? "—";
      const quantityLiters = Number(o.fuel_quantity ?? o.quantityLiters ?? o.quantity ?? 0);
      const amount = Number(o.order_total ?? o.amount ?? o.total ?? 0);
      const createdAt = o.createdAt ?? o.created_at ?? o.updatedAt ?? o.updated_at ?? null;

      let orderStatus = "pending";
      if (o.is_deleted || o.is_refunded) orderStatus = "cancelled";
      else if (o.is_completed === true || o.is_completed === "true") orderStatus = "completed";
      else if (o.is_accepted === true || o.is_accepted === "true") orderStatus = "accepted";

      return {
        __raw: o,
        id,
        orderNumber,
        customerName,
        vehicleNumber,
        quantityLiters,
        amount,
        orderStatus,
        createdAt,
        pumpName: o.pump?.brand ?? o.pumpName ?? o.pump?.name ?? "—",
      };
    });
  }, [managerOrders]);

  // filter by pump and search
  const filteredOrders = useMemo(() => {
    const byPump = currentPump
      ? mappedOrders.filter((r) => {
          const rawPumpId = r.__raw?.pump_id ?? r.__raw?.pump?._id ?? r.__raw?.pumpId;
          if (rawPumpId && currentPump?._id) return String(rawPumpId) === String(currentPump._id);
          // fallback to brand/name match
          return String(r.pumpName).toLowerCase() === String(currentPump?.brand ?? currentPump?.pumpName ?? "").toLowerCase();
        })
      : mappedOrders.slice();

    if (!debouncedSearch || debouncedSearch.trim() === "") return byPump;

    const q = debouncedSearch.trim().toLowerCase();
    return byPump.filter((r) => {
      return (
        String(r.orderNumber).toLowerCase().includes(q) ||
        String(r.customerName ?? "").toLowerCase().includes(q) ||
        String(r.vehicleNumber ?? "").toLowerCase().includes(q) ||
        String(r.pumpName ?? "").toLowerCase().includes(q) ||
        String(r.amount ?? "").toLowerCase().includes(q)
      );
    });
  }, [mappedOrders, currentPump, debouncedSearch]);

  const columns = [
    { key: "orderNumber", label: "Order #", width: "150px" },
    { key: "customerName", label: "Customer" },
    { key: "vehicleNumber", label: "Vehicle" },
    {
      key: "quantityLiters",
      label: "Quantity (L)",
      render: (v) => `${v} L`,
    },
    {
      key: "amount",
      label: "Amount",
      render: (v) => `₹${Number(v).toLocaleString("en-IN")}`,
    },
    {
      key: "orderStatus",
      label: "Status",
      render: (value) => <StatusBadge status={value} type="order" />,
    },
    {
      key: "createdAt",
      label: "Created",
      render: (value) => (value ? new Date(value).toLocaleDateString("en-IN") : "-"),
    },
    {
      key: "actions",
      label: "Actions",
      sortable: false,
      render: (value, row) => {
        if (row.orderStatus === "pending") {
          return (
            <div className="order-actions">
              <Button
                size="small"
                variant="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  handleAcceptBooking(row);
                }}
              >
                Accept
              </Button>
              <Button
                size="small"
                variant="outline"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCancelBooking(row);
                }}
              >
                Decline
              </Button>
            </div>
          );
        } else if (row.orderStatus === "accepted") {
          return (
            <Button
              size="small"
              variant="primary"
              onClick={(e) => {
                e.stopPropagation();
                handleOpenCompleteModal(row);
              }}
            >
              Mark Complete
            </Button>
          );
        }
        return "-";
      },
    },
  ];

  // Accept booking
  const handleAcceptBooking = async (row) => {
    const bookingId = row.id ?? row.__raw?._id;
    if (!bookingId) {
      showToast("Invalid booking id", "error");
      return;
    }

    try {
      await apiService.acceptBooking(bookingId);
      showToast("Order accepted", "success");
      // refresh manager orders
      const { promise } = fetchManagerOrdersWithAbort({ page: 1, limit: 200 });
      promise.catch((err) => console.error("refresh after accept failed:", err));
    } catch (err) {
      console.error("acceptBooking error:", err);
      showToast("Failed to accept order", "error");
    }
  };

  // Cancel/Decline booking
  const handleCancelBooking = async (row) => {
    const bookingId = row.id ?? row.__raw?._id;
    if (!bookingId) {
      showToast("Invalid booking id", "error");
      return;
    }

    try {
      await apiService.cancelBooking(bookingId);
      showToast("Order declined", "info");
      // refresh
      const { promise } = fetchManagerOrdersWithAbort({ page: 1, limit: 200 });
      promise.catch((err) => console.error("refresh after cancel failed:", err));
    } catch (err) {
      console.error("cancelBooking error:", err);
      showToast("Failed to decline order", "error");
    }
  };

  // Open modal to complete
  const handleOpenCompleteModal = (row) => {
    setSelectedOrder(row);
    setCompleteForm({ otp: "", billImage: null });
    setIsCompleteModalOpen(true);
  };

  // Complete booking (with optional otp & bill image)
  const handleCompleteBooking = async () => {
    const bookingId = selectedOrder?.id ?? selectedOrder?.__raw?._id;
    if (!bookingId) {
      showToast("Invalid booking id", "error");
      return;
    }
    if (!completeForm.otp) {
      showToast("Please enter OTP", "error");
      return;
    }

    try {
      await apiService.completeBooking(bookingId, {
        otp: completeForm.otp,
        billImage: completeForm.billImage,
      });
      showToast("Order marked as completed", "success");
      setIsCompleteModalOpen(false);
      // refresh
      const { promise } = fetchManagerOrdersWithAbort({ page: 1, limit: 200 });
      promise.catch((err) => console.error("refresh after complete failed:", err));
    } catch (err) {
      console.error("completeBooking error:", err);
      showToast("Failed to complete order", "error");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setCompleteForm((prev) => ({ ...prev, billImage: file }));
      showToast("Bill image selected", "info");
    }
  };

  return (
    <div className="manager-orders">
      <PageHeader title="Orders" />

      <div style={{ marginBottom: 12, maxWidth: 420 }}>
        <Input
          placeholder="Search orders by order #, customer, vehicle, pump or amount..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      <DataTable columns={columns} data={filteredOrders} searchable={false} />

      {filteredOrders.length === 0 && <div style={{ padding: 16, color: "#666" }}>No orders found.</div>}

      <Modal
        isOpen={isCompleteModalOpen}
        onClose={() => {
          setIsCompleteModalOpen(false);
          setCompleteForm({ otp: "", billImage: null });
        }}
        title="Mark Order as Completed"
        size="medium"
      >
        {selectedOrder && (
          <div className="complete-order-form">
            <div className="order-summary">
              <p>
                <strong>Order:</strong> {selectedOrder.orderNumber}
              </p>
              <p>
                <strong>Customer:</strong> {selectedOrder.customerName ?? selectedOrder.__raw?.user?.name}
              </p>
              <p>
                <strong>Quantity:</strong> {selectedOrder.quantityLiters} Liters
              </p>
              <p>
                <strong>Amount:</strong> ₹{Number(selectedOrder.amount).toLocaleString("en-IN")}
              </p>
            </div>

            <div className="form-section">
              <label className="file-upload-label">
                Upload Bill Image
                <input type="file" accept="image/*" onChange={handleFileChange} className="file-upload-input" />
                <span className="file-upload-button">Choose File</span>
                {completeForm.billImage && <span className="file-upload-name">{completeForm.billImage.name}</span>}
              </label>
            </div>

            <Input
              label="Customer OTP"
              type="text"
              placeholder="Enter OTP"
              value={completeForm.otp}
              onChange={(e) => setCompleteForm((prev) => ({ ...prev, otp: e.target.value }))}
            />

            <div className="modal-actions">
              <Button
                variant="outline"
                onClick={() => {
                  setIsCompleteModalOpen(false);
                  setCompleteForm({ otp: "", billImage: null });
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={handleCompleteBooking}>
                Confirm Completion
              </Button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ManagerOrders;

